export default class ImageModal {
  constructor() {
    this.classes = ['.slide--image', '.block-slider-gallery__item'];

    this.classes.map((cls) => {
      $(cls).on('click', (e) => {
        this.initImageModal($(e.currentTarget).find('img'));
      })
    })
  }

  initImageModal(image) {
    $('body').css({ 'overflow': 'hidden' })
    let imageSrc = image.data('full-image');
    let imageAlt = image.attr("alt");
    let description = '';
    let title = '';
    let cssClass
    if (image.hasClass('block-slider-gallery__item__image')) {
      description = image.closest('.block-slider-gallery__item').find('.block-slider-gallery__item__description')
      title = image.closest('.block-slider-gallery__item').find('.block-slider-gallery__item__title');
      cssClass = ' has-description'
    }
    $('.imgal-container').hide();
    $('body').append(
      '<div class="imgal-modal' + cssClass + '">' +
      '<span id="imgal-modal-close"">X</span>' +
      '<div class="modal-content">' +
      '<img src="' + imageSrc + '" alt="' + imageAlt + '" class="imgal-modal-img"></img>' +
      '<div class="modal-inner-content"><h3>' + title.text() + '</h3>' +
      '<p>' + description.text() + '</p>' +
      '</div></div></div>'
    );
    $('#imgal-modal-close').click(function () {
      $('.imgal-modal').remove();
      $('body').css({ 'overflow': 'auto' })
    });
  }
}



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ukrainian-museum-theme/src/scripts/modules/imageModal.js